/* Whether the visitor is plausibly typing on a physical keyboard.
   `(pointer: fine)` is the closest signal the platform offers: a phone or tablet
   reports a coarse pointer, a laptop or desktop a fine one. Used to decide whether a
   hardware-keyboard affordance is worth showing at all, and whether stealing focus on
   mount is helpful or hostile.

   Answers `false` on the server and in any environment that cannot be asked, so it is
   only ever read after mount -- never during render, or the two passes disagree. */
export function hasPhysicalKeyboard(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;

  try {
    return window.matchMedia("(pointer: fine)").matches;
  } catch {
    return false;
  }
}
